// react-international-phone keeps the dial code in the value, so a bare "+971" means the field is empty.
export const getPhoneError = (label, value, dialCode) => {
    const digits = String(value || '').replace(/\D/g, '');
    if (!digits || digits === String(dialCode)) return `${label} is required`;
    if (!/^\+\d{9,15}$/.test(String(value).replace(/[\s-]/g, ''))) return `Enter a valid ${label.toLowerCase()}`;
    return null;
};

// EDIT variant: legacy members may have no number stored — an empty field means
// "keep as is" (the backend preserves the stored value for blanks), so only a
// PARTIALLY entered number is an error.
export const getOptionalPhoneError = (label, value, dialCode) => {
    const digits = String(value || '').replace(/\D/g, '');
    if (!digits || digits === String(dialCode)) return null;
    if (!/^\+\d{9,15}$/.test(String(value).replace(/[\s-]/g, ''))) return `Enter a valid ${label.toLowerCase()}`;
    return null;
};

// A bare dial code must reach the backend as '' (meaning "keep stored value"),
// not as '+971' — which would fail E.164 and overwrite nothing meaningfully.
export const normalizePhoneForSubmit = (value, dialCode) => {
    const cleaned = String(value || '').replace(/[\s-]/g, '');
    const digits = cleaned.replace(/\D/g, '');
    return (!digits || digits === String(dialCode)) ? '' : cleaned;
};
